import i18n, { jobBoardI18n } from '@/i18n';

const localizationRequestInterceptor = function (config: any) {
   config.headers = {
      ...config.headers,
      'Accept-Language': import.meta.env.MODE === 'public' ? jobBoardI18n.global.locale.value : i18n.global.locale.value,
   };

   return config;
};

export { localizationRequestInterceptor };
